import React, { useState, useEffect } from 'react'
import { ScrollView, TouchableOpacity, StyleSheet, Image, Text, View, Alert, TextInput, Modal, Platform, ActivityIndicator } from 'react-native'
import Constants from 'expo-constants'
import { Feather } from '@expo/vector-icons'
import * as ImagePicker from 'expo-image-picker'
import {
    signOut,
    getCurrentUser,
    verifyUserAttribute,
    updateUserAttributes,
    fetchUserAttributes,
    sendUserAttributeVerificationCode,
    updateUserAttribute,
} from 'aws-amplify/auth'
import { getAuthToken, getDeviceInfo, validateConnectionNetwork } from '../../utils/functions.utils'
import { uploadData } from 'aws-amplify/storage'
import theme from '../../../theme'
import awsconfig from '../../aws-exports'
import { useDeviceStore } from '../../redux/zustand/deviceInfoStore'
import {
    addUser,
    openDB,
    updateGlobalVersion,
    deleteAllTables,
    deleteAllTablesContent,
    deleteDB,
    updateUser,
    getGlobalVersion,
    getUser,
} from '../../db/indexDB'
import { apiUrl } from '../../config/config'
import { manipulateAsync, FlipType, SaveFormat } from 'expo-image-manipulator'
import NetInfo from '@react-native-community/netinfo'
import { getImageStogeUrl } from '../imageUploader/ImageStorage'
import styles from './EditProfileScreenStyles'
import { avatarPlaceholder, getAvatarPlaceholderLocal } from '../customUtils/Constants'
import { safeImageSource } from '../../utils/imageUtils'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { StatusBar } from 'react-native'
import { SelectList } from 'react-native-dropdown-select-list'
import { getConection } from '../appBar/context/HeaderContext'
import { colorButtonTextEnabled } from '../../../themeConstants'
import { updateAttributesCognito, verifyEmailCode, verifyPhoneNumberCode } from '../../utils/cognitoUtils'
import { request_edit_user_profile, request_get_user_profile } from '../../services/user.services'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import EmailWidget from '../customUtils/Components/EmailWidget'
import { isEnabledEditParams } from './ProfileScreen'
import { getAppVersion } from '../customUtils/AppConstants'
import { getPlatform } from '@/utils/platformUtils'
import { useIsMobile } from '@/redux/zustand/useDimensionStore'
import { UserAvatarWeb } from '../web/UserAvatarWeb'
import { sideBarStore } from '@/redux/zustand/sideBarStore'

// Storage.configure(awsconfig) // TODO: Migrar a Amplify v6
const PREFIX = '+549'
const fontScale = 1
const iconSize = 18 * fontScale

export default function EditProfileScreen({ user_data, avatar, onSave, activeButtonDeleted, onClickDelete }) {
    const { deviceId, token_notification } = useDeviceStore()
    const [photoURL, setPhotoURL] = useState(avatar)
    const [avatarUrl, setAvatarUrl] = useState(user_data?.avatar)
    const [selectedImage, setSelectedImage] = useState(null)
    const defaultLanguage = user_data?.lenguage ?? ''
    const [newLanguage, setNewLanguage] = useState(defaultLanguage)
    const [showLanguageAlert, setShowLanguageAlert] = useState(false)
    const [showModalVerification, setShowModalVerification] = useState(false)
    const [showModalVerificationPhone, setShowModalVerificationPhone] = useState(false)
    const [verificationCode, setVerificationCode] = useState('')
    const [verificationCodePhone, setVerificationCodePhone] = useState('')
    const [verifiedEmail, setVerifiedEmail] = useState(user_data?.email_verified || false)
    const [verifiedPhone, setVerifiedPhone] = useState(user_data?.phone_verified || false)
    const [isButtonDisabledEmail, setIsButtonDisabledEmail] = useState(false)
    const [isButtonDisabledPhone, setIsButtonDisabledPhone] = useState(false)
    const [timerEmail, setTimerEmail] = useState(0)
    const [timerPhone, setTimerPhone] = useState(0)
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const [user, setUser] = useState()
    const [cognitoHasEmail, setCognitoHasEmail] = useState(false)
    const [cognitoHasPhone, setCognitoHasPhone] = useState(false)
    const [updating, isUpdating] = useState(false)
    const fieldsMap = {
        Email: 'email',
        Teléfono: 'phone',
        Nombre: 'name',
        Apellido: 'last_name',
        Rol: 'role',
        ...(isEnabledEditParams() && { Area: 'area' }),
    }
    const { isConnected, hasInternet } = getConection()
    const [formData, setFormData] = useState(() => {
        const initialFormData = {}
        for (const key in fieldsMap) {
            if (user_data.hasOwnProperty(fieldsMap[key])) {
                initialFormData[key] = user_data[fieldsMap[key]]
            }
        }
        return initialFormData
    })

    const { languageFile } = getLanguage()

    const [languages, setLanguages] = useState(user_data.languages ?? [])
    const { setSideBarMarginRight } = sideBarStore()
    useEffect(() => {
        setSideBarMarginRight(0)

        return () => {
            setSideBarMarginRight()
        }
    }, [])
    // Timer para el botón de verificación de Email
    useEffect(() => {
        let interval
        if (timerEmail > 0) {
            interval = setInterval(() => {
                setTimerEmail((prevTimer) => prevTimer - 1)
            }, 1000)
        } else if (timerEmail === 0 && isButtonDisabledEmail) {
            setIsButtonDisabledEmail(false)
        }
        return () => clearInterval(interval)
    }, [timerEmail, isButtonDisabledEmail])

    // Timer para el botón de verificación de Teléfono
    useEffect(() => {
        let interval
        if (timerPhone > 0) {
            interval = setInterval(() => {
                setTimerPhone((prevTimer) => prevTimer - 1)
            }, 1000)
        } else if (timerPhone === 0 && isButtonDisabledPhone) {
            setIsButtonDisabledPhone(false)
        }
        return () => clearInterval(interval)
    }, [timerPhone, isButtonDisabledPhone])

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const hasConnection = await validateConnectionNetwork()
                console.log('🚀 ~ fetchUser ~ hasConnection:', hasConnection)
                if (!hasConnection) {
                    return
                }

                const userAttributes = await fetchUserAttributes()

                const hasEmail = !!(userAttributes?.email && userAttributes.email.trim() !== '')
                const hasPhone = !!(userAttributes?.phone_number && userAttributes.phone_number.trim() !== '')

                setCognitoHasEmail(hasEmail)
                setCognitoHasPhone(hasPhone)

                if (hasEmail) {
                    setVerifiedEmail(userAttributes?.email_verified || false)
                }
                if (hasPhone) {
                    setVerifiedPhone(userAttributes?.phone_number_verified || false)
                }
            } catch (error) {
                console.error('Error al obtener el usuario autenticado:', error)
            }
        }

        fetchUser()
    }, [])

    const fetchData = async () => {
        try {
            let data
            const database = await openDB()
            const currentGlobalVersion = await getGlobalVersion(database, 'user')
            const netInfoState = await NetInfo.fetch()
            let user = await getUser(database)
            console.log('🚀 ~ fetchData ~ user from DB:', user)
            if (user) {
                setUser(user)
            }
            if (netInfoState.isConnected && netInfoState.isInternetReachable) {
                const authToken = await getAuthToken()
                if (!authToken) return
                // authToken ya obtenido por getAuthToken
                const device_param = {
                    device_key: deviceId,
                    token_notification: token_notification,
                }
                const headersParam = {
                    version: currentGlobalVersion,
                    device_key: deviceId,
                    device: JSON.stringify(device_param),
                    app_version: getAppVersion(), //expo.expo.android.versionCode.toString(),
                    system: getPlatform().OS,
                    deviceInfo: JSON.stringify(getDeviceInfo()),
                }
                data = await request_get_user_profile({ authToken, headersParam })

                console.log('🚀 ~ fetchData ~ data from API:', data)

                if (data) {
                    // if (data?.single?.delete_active) {
                    //     setActiveButtonDeleted(data.single.delete_active)
                    // }
                } else {
                    data = {
                        status: 0, // Asume un status 0 que es cuando tiene la misma version que la api // si paso status 2 tomo la data harcodeada
                    }
                }
            } else {
                data = {
                    status: 0, // Asume un status 0 que es cuando tiene la misma version que la api // si paso status 2 tomo la data harcodeada
                }
            }

            console.log('[ProfileScreen] fetchData status:', data?.status, 'platform:', Platform.OS)
            if (data?.status === 1) {
                // Amplify v6: tokens están en session.tokens
                const userAttributes = await fetchUserAttributes()
                console.log('🚀 ~ fetchData ~ userAttributes:', userAttributes)
                // const sub = session?.tokens?.idToken?.payload?.sub || null
                const sub = userAttributes?.sub || null
                const user_data = {
                    ...data.single.user_data,
                    delete_active: data.single.delete_active,
                    languages: data.single.languages,
                    login: true,
                    cognito_id: sub,
                    showClearCacheButton: data.single.showClearCacheButton ?? false,
                }
                setVerifiedEmail(user_data?.email_verified || false)
                setVerifiedPhone(user_data?.phone_verified || false)
                setUser(user_data)

                const initialFormData = {}
                try {
                    console.log('[ProfileScreen] user_data keys (online):', Object.keys(user_data || {}))
                } catch {}
                // for (const key in fieldsMap) {
                //     if (user_data && Object.prototype.hasOwnProperty.call(user_data, fieldsMap[key])) {
                //         initialFormData[key] = user_data[fieldsMap[key]]
                //     }
                // }
                // if (user_data.languages && user_data.languages.length > 0) {
                //     setLanguages(user_data.languages)
                // }
                // const defaultLanguage = user_data.lenguage ?? ''
                // setDefaultLanguage(defaultLanguage)
                // const photo_url = user_data.avatar_image ?? ''
                // setPhotoURL(photo_url)
                // setFormData(initialFormData)

                // Guardar usuario
                try {
                    await addUser(database, user_data)
                } catch {}
                let version_update = data.single.user_data.data_version ? data.single.user_data.data_version : 0
                await updateGlobalVersion(database, 'user', version_update)
                return data.single.user_data
            } else {
                try {
                    // Rama offline o sin actualización
                    setVerifiedEmail(user?.email_verified || false)
                    setVerifiedPhone(user?.phone_verified || false)
                    const initialFormData = {}
                    try {
                        console.log('[ProfileScreen] user keys (offline):', Object.keys(user || {}))
                    } catch {}
                    // Fallback: si no hay usuario local pero hay conectividad, forzar fetch completo (version=0)
                    if ((!user || Object.keys(user).length === 0) && netInfoState.isConnected && netInfoState.isInternetReachable) {
                        try {
                            console.log('[ProfileScreen] No local user found; forcing full profile fetch...')
                            // Recontruir session y headers acá (no existen en este scope)
                            const authToken = await getAuthToken()
                            if (!authToken) return
                            const device_param2 = {
                                device_key: deviceId,
                                token_notification: token_notification,
                            }
                            const headersParam2 = {
                                version: '0',
                                device_key: deviceId,
                                device: JSON.stringify(device_param2),
                                app_version: getAppVersion(),
                                system: getPlatform().OS,
                                deviceInfo: JSON.stringify(getDeviceInfo()),
                            }
                            const forced = await request_get_user_profile({
                                authToken: authToken,
                                headersParam: headersParam2,
                                retries: 1,
                                timeout: 5,
                            })
                            if (forced?.status === 1) {
                                const forcedUser = {
                                    ...forced.single.user_data,
                                    delete_active: forced.single.delete_active,
                                    languages: forced.single.languages,
                                    login: true,
                                    cognito_id: null,
                                    showClearCacheButton: forced.single.showClearCacheButton ?? false,
                                }
                                setUser(forcedUser)
                                setVerifiedEmail(forcedUser?.email_verified || false)
                                setVerifiedPhone(forcedUser?.phone_verified || false)
                                for (const key in fieldsMap) {
                                    if (forcedUser && Object.prototype.hasOwnProperty.call(forcedUser, fieldsMap[key])) {
                                        initialFormData[key] = forcedUser[fieldsMap[key]]
                                    }
                                }
                                // if (forcedUser.languages && forcedUser.languages.length > 0) {
                                //     setLanguages(forcedUser.languages)
                                // }
                                // const defaultLanguage2 = forcedUser.lenguage ?? ''
                                // setNewLanguage(defaultLanguage2)
                                // // setDefaultLanguage(defaultLanguage2)
                                // const photo_url2 = forcedUser.avatar_image ?? ''
                                // setPhotoURL(photo_url2)
                                // setFormData(initialFormData)
                                try {
                                    await addUser(database, forcedUser)
                                } catch {}
                                let version_update2 = forced.single.user_data.data_version ? forced.single.user_data.data_version : 0
                                await updateGlobalVersion(database, 'user', version_update2)
                                console.log('[ProfileScreen] Forced fetch succeeded; populated formData keys:', Object.keys(initialFormData))
                                return forced.single.user_data
                            }
                        } catch (e) {
                            console.log('[ProfileScreen] Forced fetch failed:', e?.message || e)
                        }
                    }
                    if (user) {
                        for (const key in fieldsMap) {
                            if (user && Object.prototype.hasOwnProperty.call(user, fieldsMap[key])) {
                                initialFormData[key] = user[fieldsMap[key]]
                            }
                        }
                    }
                    try {
                        console.log('[ProfileScreen] initialFormData keys (offline):', Object.keys(initialFormData))
                    } catch {}
                    // if (user?.languages && user.languages.length > 0) {
                    //     setLanguages(user.languages)
                    // }
                    // const defaultLanguage = user?.lenguage ?? ''
                    // setNewLanguage(defaultLanguage)
                    // setDefaultLanguage(defaultLanguage)
                    // const photo_url = user?.avatar ?? ''
                    // setPhotoURL(photo_url)
                    // setFormData(initialFormData)
                    return user
                } catch (error) {
                    console.log('🚀 ~ user= ~ error:', error)
                }
            }
        } catch (error) {
            console.error('Error al obtener el usuario autenticado:fetch data profile', error)
        }
    }

    const handleVerificationClick = (type) => {
        // console.log('handleVerificationClick type:', type)
        handleResendCode(type)

        if (type === 'email') {
            setIsButtonDisabledEmail(true)
            setTimerEmail(120) // 2 minutos = 120 segundos
        } else if (type === 'phone') {
            setIsButtonDisabledPhone(true)
            setTimerPhone(120) // 2 minutos = 120 segundos
        }
    }

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60)
        const remainingSeconds = seconds % 60
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
    }

    const editPhoto = async () => {
        try {
            if (Platform.OS === 'web') {
                // En web, usar input file nativo
                const input = document.createElement('input')
                input.type = 'file'
                input.accept = 'image/*'
                input.onchange = async (e) => {
                    const file = e.target.files[0]
                    if (file) {
                        // Crear un objeto URL para la imagen
                        const uri = URL.createObjectURL(file)
                        // Simular el resultado de ImagePicker
                        const pickerResult = {
                            cancelled: false,
                            uri: uri,
                            width: 0,
                            height: 0,
                            type: 'image',
                        }
                        await handleImagePickerResult(pickerResult, file)
                    }
                }
                input.click()
            } else {
                //revisar esto por problemas con los mensajes que tiene IOS para hacer el ipa //
                const cameraPermissionResult = await ImagePicker.requestCameraPermissionsAsync()
                const mediaLibraryPermissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync()

                if (cameraPermissionResult.granted === false || mediaLibraryPermissionResult.granted === false) {
                    Alert.alert(languageFile.insufficient_permissions, languageFile.permissions_to_access)
                    return
                }

                const options = {
                    allowsEditing: true,
                    aspect: [1, 1],
                    quality: 0.3, //1, // la calidad 1 es la mas alta disponible, si  se quiere una calidad baja se puede poner un numero entre 0 y 1, ej, 0.5 y reduce la calidad a la mitad
                }

                Alert.alert(
                    languageFile.choose_font,
                    languageFile.select_the_image,
                    [
                        {
                            text: languageFile.camera,
                            onPress: async () => {
                                const pickerResult = await ImagePicker.launchCameraAsync(options)
                                handleImagePickerResult(pickerResult)
                            },
                        },
                        {
                            text: languageFile.gallery,
                            onPress: async () => {
                                const pickerResult = await ImagePicker.launchImageLibraryAsync(options)
                                handleImagePickerResult(pickerResult)
                            },
                        },
                    ],
                    { cancelable: true },
                )
            }
        } catch (error) {
            console.error('Error al solicitar permisos de cámara o galería:', error)
        }
    }

    const handleImagePickerResult = async (pickerResult, webFile = null) => {
        if (!pickerResult.cancelled) {
            try {
                let blob

                if (Platform.OS === 'web' && webFile) {
                    // En web, usar el archivo directamente
                    blob = webFile
                } else {
                    // En mobile, hacer fetch del URI
                    const response = await fetch(pickerResult.uri)
                    blob = await response.blob()
                }

                const timestamp = Date.now()
                const filename = `avatars/profile-${user_data._id}-${timestamp}.jpg`
                const thumbnailFilename = `avatars/profile-thumbnail-${user_data._id}-${timestamp}.jpg`

                let sube = await uploadData({
                    key: filename,
                    data: blob,
                    options: {
                        contentType: 'image/jpeg',
                    },
                }).result

                const imageUrl = await getImageStogeUrl(filename)
                setPhotoURL(imageUrl)
                setSelectedImage({ avatar: filename, thumbnail: thumbnailFilename })

                const updateProfileWithAvatar = async () => {
                    try {
                        const authToken = await getAuthToken()
                        if (!authToken) {
                            console.error('[EditProfile] no authToken; skipping avatar update')
                            return
                        }

                        const editedData = {
                            avatar_image: filename,
                            avatar_image_thumbnail: thumbnailFilename,
                        }

                        const response = await fetch(`${apiUrl}/edit_user_profile`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: authToken,
                            },
                            body: JSON.stringify({
                                user_data: editedData,
                            }),
                        })

                        if (!response.ok) {
                            throw new Error('Fallo al actualizar el avatar')
                        }

                        const data = await response.json()

                        if (data?.status === 1) {
                            const database = await openDB()
                            const user_data_updated = {
                                ...data.single.user_data,
                                delete_active: data.single.delete_active,
                                languages: languages,
                            }
                            await updateUser(database, user_data_updated._id, user_data_updated)
                            setAvatarUrl(imageUrl)

                            if (onSave) {
                                onSave(user_data_updated)
                            }
                        }
                    } catch (error) {
                        console.error('Error al actualizar avatar en perfil:', error)
                    }
                }

                // Crear thumbnail solo en mobile (manipulateAsync no funciona en web)
                if (Platform.OS !== 'web') {
                    const thumbnailOptions = {
                        compress: 0.5,
                        format: 'jpeg',
                        base64: false,
                        width: 100,
                        height: 100,
                    }
                    const thumbnailResult = await manipulateAsync(pickerResult.uri, [{ resize: thumbnailOptions }], {
                        compress: 0.5,
                        format: 'jpeg',
                        base64: false,
                    })

                    const thumbnailResponse = await fetch(thumbnailResult.uri)
                    const thumbnailBlob = await thumbnailResponse.blob()
                    const thumbnailSube = await uploadData({
                        key: thumbnailFilename,
                        data: thumbnailBlob,
                        options: {
                            contentType: 'image/jpeg',
                        },
                    }).result
                    const thumbnailImageUrl = await getImageStogeUrl(thumbnailFilename)
                    console.log('🚀 ~ thumbnailImageUrl:', thumbnailImageUrl)

                    await updateProfileWithAvatar()
                } else {
                    // En web, crear thumbnail usando canvas
                    const img = document.createElement('img')
                    img.src = pickerResult.uri

                    await new Promise((resolve) => {
                        img.onload = resolve
                    })

                    const canvas = document.createElement('canvas')
                    const ctx = canvas.getContext('2d')
                    canvas.width = 100
                    canvas.height = 100

                    ctx.drawImage(img, 0, 0, 100, 100)

                    canvas.toBlob(
                        async (thumbnailBlob) => {
                            if (thumbnailBlob) {
                                const thumbnailSube = await uploadData({
                                    key: thumbnailFilename,
                                    data: thumbnailBlob,
                                    options: {
                                        contentType: 'image/jpeg',
                                    },
                                }).result
                                const thumbnailImageUrl = await getImageStogeUrl(thumbnailFilename)

                                await updateProfileWithAvatar()
                            }
                        },
                        'image/jpeg',
                        0.5,
                    )
                }
            } catch (error) {
                console.error('Error al subir la imagen:', error)
            }
        }
    }

    const handleFormChange = (key, value) => {
        setFormData({
            ...formData,
            [key]: value,
        })
    }
    const updateProfile = async (formData) => {
        closeBottomSheet(true) // Cerrar el BottomSheet
        isUpdating(true)
        await new Promise((resolve) => setTimeout(resolve, 3000))

        try {
            let data
            const authToken = await getAuthToken()
            if (!authToken) {
                console.warn('[EditProfile] no authToken; skipping remote profile update')
                return
            }
            // const user = await getCurrentUser()
            // const database = await openDB()
            let originalEmail = user_data['email'] && user_data['email'].toString().trim() ? user_data['email'].toString().trim() : null
            let originalPhone = user_data['phone'] && user_data['phone'].toString().trim() ? user_data['phone'].toString().trim() : null
            let editedData = {}
            console.log('🚀 ~ updateProfile ~ formData:', formData)
            for (const key in formData) {
                if (formData.hasOwnProperty(key) && formData[key] !== user_data[fieldsMap[key]]) {
                    editedData[fieldsMap[key]] = formData[key]
                }
            }

            console.log('🚀 ~ updateProfile ~ editedData:', editedData)

            const netInfoState = await NetInfo.fetch()
            if (netInfoState.isConnected) {
                // if (selectedImage) {
                //     editedData = {
                //         ...editedData,
                //         avatar_image: selectedImage.avatar,
                //         avatar_image_thumbnail: selectedImage.thumbnail,
                //     }
                // }
                if (newLanguage != '' && formData.language !== defaultLanguage) {
                    editedData = {
                        ...editedData,
                        language: newLanguage,
                    }
                }

                if (formData['Email'].toString().trim() != originalEmail) {
                    //updateo en cognito el mail

                    const updateRes = await updateUserAttribute({
                        userAttribute: {
                            attributeKey: 'email',
                            value: formData['Email'].toString().trim(),
                        },
                    })

                    console.log('📲 updateUserAttribute email:', updateRes)

                    editedData = {
                        ...editedData,
                        email_pending: editedData['Email'],
                    }

                    if (updateRes && updateRes.nextStep.updateAttributeStep === 'CONFIRM_ATTRIBUTE_WITH_CODE') {
                        openBottomSheet(
                            <EmailWidget
                                type={'email'}
                                formData={formData}
                                user_data={user_data}
                                closeBottomSheet={(dat) => closeBottomSheet(dat)}
                                fieldsMap={fieldsMap}
                                fetchData={fetchData}
                            />,
                        )
                        // setShowModalVerification(true)
                    }
                }

                console.log('originalPhone', originalPhone)
                console.log('formData', formData['Teléfono'])
                if (formData['Teléfono'].toString().trim() != originalPhone) {
                    //updateo en cognito el mail

                    let phone_number = formData['Teléfono'].toString().trim()

                    const updateRes = await updateUserAttribute({
                        userAttribute: {
                            attributeKey: 'phone_number',
                            value: phone_number,
                        },
                    })
                    console.log('📲 updateUserAttribute phone_number:', updateRes)

                    editedData = {
                        ...editedData,
                        phone_pending: phone_number, //!phone_number.startsWith('+549') ? `+549${editedData['Teléfono']}` : editedData['Teléfono']
                    }

                    if (updateRes && updateRes.nextStep.updateAttributeStep === 'CONFIRM_ATTRIBUTE_WITH_CODE') {
                        openBottomSheet(
                            <EmailWidget
                                type={'phone'}
                                formData={formData}
                                user_data={user_data}
                                closeBottomSheet={(dat) => closeBottomSheet(dat)}
                                fieldsMap={fieldsMap}
                                fetchData={fetchData}
                            />,
                        )

                        // setShowModalVerificationPhone(true)
                    }
                }

                let filterEditedData = Object.keys(editedData)
                    .filter((key) => key !== 'email' && key !== 'phone')
                    .reduce((result, key) => {
                        result[key] = editedData[key]
                        return result
                    }, {})

                // console.log('filterEditedData', filterEditedData)

                const response = await fetch(`${apiUrl}/edit_user_profile`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: authToken,
                    },
                    body: JSON.stringify({
                        user_data: filterEditedData,
                    }),
                })

                if (!response.ok) {
                    throw new Error('Fallo al obtener el usuario')
                }

                data = await response.json()
                isUpdating(false)
                // console.log('🚀 ~ update users:', data)
            } else {
                console.log('sin conexion')
                data = {
                    status: 0,
                }
                isUpdating(false)
            }

            if (data?.status === 1) {
                const database = await openDB()
                try {
                    const user_data = { ...data.single.user_data, delete_active: data.single.delete_active, languages: languages }
                    console.log('DATA USER', user_data)
                    //await addUser(database, user_data)
                    await updateUser(database, user_data._id, { languages })
                } catch (error) {
                    console.error('Error al agregar usuario:', error)
                }
                // let version_update = data.single.user_data.data_version ? data.single.user_data.data_version : 0
                // await updateGlobalVersion(database, 'user', version_update)
                console.log('Datos guardados localmente')
                // data.single.user_data.avatar = photoURL
                let dataSave = data.single.user_data
                dataSave.languages = languages
                dataSave.delete_active = data.single.delete_active ?? false
                // onSave(dataSave)
            }
        } catch (error) {
            console.error('2Error al obtener el usuario autenticado:', error)
            isUpdating(false)
        } finally {
            isUpdating(false)
        }
    }

    const onLanguageChange = (val) => {
        setNewLanguage(val)
        setShowLanguageAlert(true)
    }

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen)
    }

    const handleModalVerification = async (verificationCode) => {
        const authToken = await getAuthToken()
        if (!authToken) return
        let verifyCode = await verifyEmailCode(verificationCode)
        let editedData = {}

        for (const key in formData) {
            if (formData.hasOwnProperty(key) && formData[key] !== user_data[fieldsMap[key]]) {
                editedData[fieldsMap[key]] = formData[key]
            }
        }
        if (verifyCode['success']) {
            setShowModalVerification(false)
            let update_profile = await request_edit_user_profile(authToken, editedData, undefined)
            navigation.navigate('Profile')
        }
    }

    const handleModalCode = () => {
        setShowModalVerification(false)
    }

    const handleModalVerificationPhone = async (verificationCode) => {
        const authToken = await getAuthToken()
        if (!authToken) return
        let verifyCode = await verifyPhoneNumberCode(verificationCode)
        let editedData = {}

        for (const key in formData) {
            if (formData.hasOwnProperty(key) && formData[key] !== user_data[fieldsMap[key]]) {
                editedData[fieldsMap[key]] = formData[key]
            }
        }
        if (verifyCode['success']) {
            setShowModalVerificationPhone(false)
            let update_profile = await request_edit_user_profile(authToken, editedData, undefined)
        }
    }

    const handleResendCode = async (type) => {
        try {
            const user = await getCurrentUser()
            let response
            if (type === 'phone') {
                console.log('reenviando codigo al phone')

                // response = await verifyUserAttribute({
                //     userAttributeKey: 'phone_number',
                // })
                // console.log('📲 Verification code sent to phone:', response)

                let phone = formData['Teléfono'].startsWith('+549') ? formData['Teléfono'] : `+549${formData['Teléfono']}`

                console.log('🚀 ~ handleResendCode ~ phone:', phone)
                // response = await updateUserAttributes({ userAttributes: { phone_number: phone } }) // Reenviar código SMS

                response = await sendUserAttributeVerificationCode({
                    userAttributeKey: 'phone_number',
                })

                console.log('🚀 ~ PHONE - handleResendCode ~ response:', response)

                if (response && response.deliveryMedium === 'SMS' && response.attributeName === 'phone_number') {
                    openBottomSheet(
                        <EmailWidget
                            type={'phone'}
                            formData={formData}
                            user_data={user_data}
                            closeBottomSheet={closeBottomSheet}
                            fieldsMap={fieldsMap}
                            fetchData={fetchData}
                        />,
                    )
                    console.log('Código reenviado correctamente por SMS')
                } else {
                    throw new Error('No se pudo reenviar el código SMS')
                }
            }

            if (type === 'email') {
                console.log('reenviando codigo al email')

                response = await sendUserAttributeVerificationCode({
                    userAttributeKey: 'email',
                })

                console.log('🚀 ~ EMAIL - handleResendCode ~ response:', response)

                if (response && response.deliveryMedium === 'EMAIL' && response.attributeName === 'email') {
                    openBottomSheet(
                        <EmailWidget
                            type={'email'}
                            formData={formData}
                            user_data={user_data}
                            closeBottomSheet={closeBottomSheet}
                            fieldsMap={fieldsMap}
                            fetchData={fetchData}
                        />,
                    )
                    console.log('Código reenviado correctamente por email')
                } else {
                    throw new Error('No se pudo reenviar el código de email')
                }
            }
        } catch (error) {
            console.error('Error reenviando el código:', error.message || error)
        }
    }

    const openModalEditValue = (key) => {
        console.log('🚀🚀🚀🚀 ~ openModalEditValue ~ key:', key)
        openBottomSheet(<ModalContent fieldKey={key} />)
    }

    const ModalContent = ({ fieldKey }) => {
        const [tempValue, setTempValue] = useState(formData[fieldKey] || '')

        // Función para guardar el valor editado en el estado global (formData)
        const saveChanges = async () => {
            console.log('saveChanges => ')
            let dataEditada = ''
            if (fieldKey == 'Teléfono') {
                dataEditada = tempValue.startsWith('+549') ? tempValue : PREFIX + tempValue
            } else if (fieldKey == 'Email') {
                dataEditada = tempValue.toLowerCase().trim()
            } else {
                dataEditada = tempValue.trim()
            }

            handleFormChange(fieldKey, dataEditada) // Guardar el valor en formData

            const updatedFormData = {
                ...formData,
                [fieldKey]: dataEditada,
            }

            if (fieldKey == 'Email') {
                setVerifiedEmail(false)
            }

            if (fieldKey == 'Teléfono') {
                setVerifiedPhone(false)
            }

            // Cerrar el modal
            closeBottomSheet(true)

            // Aquí puedes llamar a updateProfile si lo necesitas
            await updateProfile(updatedFormData)
        }

        const renderText = () => {
            const mapText = {
                ['Email']: {
                    title: languageFile.editing_your_email,
                    description: languageFile.modifying_your_email,
                },
                ['Teléfono']: {
                    title: languageFile.editing_your_phone,
                    description: languageFile.modifying_your_phone,
                },
                ['Apellido']: {
                    title: 'Estás editando tu apellido',
                    description: 'Modificando tu apellido',
                },
                ['Nombre']: {
                    title: 'Estás editando tu nombre',
                    description: 'Modificando tu nombre',
                },
            }

            return mapText[fieldKey] || { title: '', description: '' }
        }

        return (
            <View style={[styles.containerModal, { width: 500, paddingHorizontal: 20, paddingTop: 28, paddingBottom: 8 }]}>
                {fieldKey === 'Email' && <Image style={styles.image} source={require('../../../assets/editEmail.png')} />}
                {fieldKey === 'Teléfono' && <Image style={styles.image} source={require('../../../assets/editPhone.png')} />}
                <Text style={styles.title}>{renderText().title}</Text>
                <Text style={styles.description}>{renderText().description}</Text>
                <View style={styles.marginBottom}></View>
                <View style={{ flexDirection: 'row', alignSelf: 'center', alignItems: 'center', width: '100%' }}>
                    {fieldKey === 'Teléfono' && <Text style={{ marginLeft: 12 }}>{PREFIX}</Text>}
                    <TextInput
                        style={[
                            styles.input,
                            styles.marginHorizontal,
                            { textAlign: 'center', marginTop: 0, marginBottom: 0, width: '100%', flex: 1 },
                        ]}
                        onChangeText={(value) => {
                            if (fieldKey === 'Teléfono') {
                                // Maneja solo los números sin el prefijo en el input
                                let rawValue = value.startsWith('+549') ? value.slice(4) : value

                                // Limita a 10 caracteres
                                if (rawValue.length <= 10) {
                                    setTempValue(rawValue)
                                }
                            } else {
                                setTempValue(value)
                            }
                        }}
                        value={tempValue && tempValue.startsWith && tempValue.startsWith('+549') ? tempValue.slice(4) : tempValue}
                        placeholder={fieldKey.charAt(0).toUpperCase() + fieldKey.slice(1)}
                        placeholderTextColor={theme.colors.textSecondary}
                        keyboardType={fieldKey === 'Email' ? 'email-address' : 'default'}
                        autoCapitalize={fieldKey === 'Email' ? 'none' : 'words'}
                        editable={true}
                    />
                </View>
                <View style={[styles.buttonContainer, styles.paddingHorizontal, styles.marginBottom]}>
                    {/* Button confirm */}
                    <TouchableOpacity onPress={() => saveChanges()} style={styles.mainButton}>
                        <Text style={styles.mainButtonText}>{languageFile.confirm}</Text>
                    </TouchableOpacity>

                    {/* Button cancel */}
                    <TouchableOpacity onPress={() => closeBottomSheet(true)} style={styles.borderRedButton}>
                        <Text style={styles.borderRedButtonText}>{languageFile.cancel}</Text>
                    </TouchableOpacity>
                    <View style={styles.spacer1}></View>
                </View>
            </View>
        )
    }
    const isMobile = useIsMobile()
    const webMaxWidth = 924
    const [dataUpdated, setDataUpdated] = useState(false)

    function updateFormData(fieldKey, tempValue) {
        let dataEditada = ''
        if (fieldKey == 'Teléfono') {
            dataEditada = tempValue.startsWith('+549') ? tempValue : PREFIX + tempValue
        } else if (fieldKey == 'Email') {
            dataEditada = tempValue.toLowerCase().trim()
        } else {
            dataEditada = tempValue.trim()
        }

        handleFormChange(fieldKey, dataEditada) // Guardar el valor en formData

        setDataUpdated(true)
        if (fieldKey == 'Email') {
            setVerifiedEmail(false)
        }

        if (fieldKey == 'Teléfono') {
            setVerifiedPhone(false)
        }
    }
    async function updateAllFields() {
        if (!dataUpdated || updating) return
        // const updatedFormData = {
        //     ...formData,
        //     [fieldKey]: dataEditada,
        // }
        // if (fieldKey == 'Email') {
        //     setVerifiedEmail(false)
        // }

        // if (fieldKey == 'Teléfono') {
        //     setVerifiedPhone(false)
        // }
        await updateProfile(formData)
        setDataUpdated(false)
    }
    return (
        <View style={[styles.container]}>
            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
            {!showLanguageAlert ? (
                <ScrollView style={[styles.scrollView, !isMobile && { alignContent: 'center' }]} showsVerticalScrollIndicator={false}>
                    <View
                        style={{
                            width: '100%',
                            maxWidth: webMaxWidth,
                            alignSelf: 'center',
                        }}
                    >
                        {/* avatar */}
                        <View style={{ flexDirection: 'row', alignContent: 'center', width: '100%' }}>
                            <View style={styles.avatar}>
                                <UserAvatarWeb style={styles.avatar} avatarUrl={avatarUrl} key={avatarUrl} />
                                <TouchableOpacity
                                    onPress={() => editPhoto()}
                                    style={{
                                        width: 30,
                                        aspectRatio: 1,
                                        backgroundColor: theme.colors.colorPrimary,
                                        borderRadius: 30,
                                        borderWidth: 3,
                                        borderColor: 'white',
                                        position: 'absolute',
                                        bottom: 0,
                                        right: -6,
                                        alignContent: 'center',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Feather name='edit-2' size={15} color={'white'} />
                                </TouchableOpacity>
                            </View>
                            <Text
                                style={{
                                    fontSize: 19,
                                    fontWeight: 'bold',
                                    alignItems: 'flex-start',
                                    color: theme.colors.textPrimary,
                                    marginBottom: 0,
                                    marginStart: 24,
                                    alignSelf: 'center',
                                }}
                            >
                                {user_data?.name} {user_data?.last_name}
                            </Text>
                        </View>

                        <View style={{ flex: 1, backgroundColor: theme.colors.colorPrimary + '14', marginTop: 24, marginBottom: 10 }}>
                            <Text style={{ color: theme.colors.colorPrimary, fontSize: 15, fontWeight: '800', margin: 6 }}>Datos de cuenta</Text>
                        </View>

                        {/* language */}
                        {isConnected && hasInternet && languages.length > 1 && (
                            <View>
                                <Text style={styles.tagInput}>{languageFile.change_language}</Text>
                                <SelectList
                                    placeholder={newLanguage}
                                    data={languages}
                                    defaultOption={newLanguage}
                                    setSelected={(val) => onLanguageChange(val)}
                                    save='value'
                                    search={false}
                                    arrowicon={<Feather name={'chevron-down'} size={22} color={theme.colors.colorPrimary} />}
                                    boxStyles={styles.input}
                                    dropdownStyles={styles.dropdown}
                                    dropdownTextStyles={styles.dropdownOptions}
                                    inputStyles={styles.dropdownInput}
                                />
                            </View>
                        )}

                        {/* data user keys */}
                        {Object.keys(formData).map((key) => (
                            <EditProfileField
                                formData={formData}
                                item={key}
                                handleVerificationClick={handleVerificationClick}
                                openModalEditValue={openModalEditValue}
                                isButtonDisabledEmail={isButtonDisabledEmail}
                                isButtonDisabledPhone={isButtonDisabledPhone}
                                timerEmail={timerEmail}
                                timerPhone={timerPhone}
                                verifiedEmail={verifiedEmail}
                                verifiedPhone={verifiedPhone}
                                updateFormData={updateFormData}
                                dataUpdated={dataUpdated}
                                cognitoHasPhone={cognitoHasPhone}
                                cognitoHasEmail={cognitoHasEmail}
                            />
                        ))}
                        <TouchableOpacity style={{ alignSelf: 'center', marginTop: 12 }} onPress={() => updateAllFields()} disabled={!dataUpdated}>
                            <Text
                                style={[
                                    {
                                        fontWeight: '700',
                                        color: 'white',
                                        backgroundColor: theme.colors.colorPrimary,
                                        borderRadius: 15,
                                        paddingVertical: 10,
                                        paddingHorizontal: 40,
                                    },
                                    !dataUpdated && { color: theme.colors.darkGray, backgroundColor: theme.colors.lightGray },
                                ]}
                            >
                                Guardar cambios
                            </Text>
                        </TouchableOpacity>
                        {showModalVerification && (
                            <Modal
                                animationType='slide'
                                transparent={true}
                                onRequestClose={() => {
                                    // Evita cerrar el modal hasta que se verifique el código
                                    console.log('El modal de verificación no se puede cerrar hasta que se complete.')
                                }}
                            >
                                <View style={[styles.modalOverlay]}>
                                    <View style={[styles.modalContainer, { maxWidth: 500 }]}>
                                        <Image style={styles.image} source={require('../../../assets/editEmail.png')} resizeMode='contain' />
                                        <Text style={styles.modalTitle}>Valida tu email</Text>
                                        <Text style={styles.modalSubtitle}>
                                            Estás modificando tu email, recibirás un cósigo en tu correo electrónico para ingresarlo.
                                        </Text>
                                        <Text style={styles.modalSubtitle}>Si aún no recibiste el código, vuelve a verificarlo.</Text>
                                        <Text style={styles.modalTitle}>Código de verificación</Text>
                                        <View style={styles.inputBlock}>
                                            <TextInput
                                                style={styles.input}
                                                placeholder={languageFile.enter_your_new_email}
                                                placeholderTextColor={theme.colors.mediumGray}
                                                onChangeText={(text) => setVerificationCode(text)}
                                                value={verificationCode}
                                                keyboardType='numeric' // Si esperas un código numérico
                                            />
                                        </View>
                                        <View style={styles.buttonContainer}>
                                            <TouchableOpacity
                                                style={[styles.mainButton, { backgroundColor: theme.colors.colorPrimary }]}
                                                onPress={() => handleModalVerification(verificationCode)}
                                            >
                                                <Text style={styles.mainButtonText}>{languageFile.confirm}</Text>
                                            </TouchableOpacity>
                                        </View>

                                        <View style={styles.buttonContainer}>
                                            <TouchableOpacity style={[styles.borderButton]} onPress={() => handleModalCode()}>
                                                <Text style={styles.borderButtonText}>{languageFile.cancel}</Text>
                                            </TouchableOpacity>
                                        </View>
                                    </View>
                                </View>
                            </Modal>
                        )}

                        {showModalVerificationPhone && (
                            <Modal
                                animationType='slide'
                                transparent={true}
                                onRequestClose={() => {
                                    // Evita cerrar el modal hasta que se verifique el código
                                    console.log('El modal de verificación no se puede cerrar hasta que se complete.')
                                }}
                            >
                                <View style={styles.modalOverlay}>
                                    <View style={[styles.modalContainer, { maxWidth: 500 }]}>
                                        <Text style={styles.modalTitle}>{languageFile.confirm_your_phone}</Text>

                                        <TextInput
                                            style={styles.input_verification}
                                            placeholder={languageFile.enter_confirmation_code}
                                            placeholderTextColor={theme.colors.mediumGray}
                                            value={verificationCodePhone}
                                            onChangeText={(text) => setVerificationCodePhone(text)}
                                            keyboardType='numeric' // Si esperas un código numérico
                                        />

                                        <TouchableOpacity
                                            style={styles.mainButton}
                                            onPress={() => handleModalVerificationPhone(verificationCodePhone)}
                                        >
                                            <Text style={styles.mainButtonText}>{languageFile.validate_code}</Text>
                                        </TouchableOpacity>
                                    </View>
                                </View>
                            </Modal>
                        )}
                    </View>
                </ScrollView>
            ) : (
                <View style={styles.containerModal}>
                    <Image style={styles.image} source={require('../../../assets/changeLanguage.png')} />
                    <Text style={styles.title}>{languageFile.change_language_title}</Text>
                    <Text style={styles.description}>{languageFile.change_language_message}</Text>

                    <View style={styles.buttonContainer}>
                        <TouchableOpacity
                            onPress={() => {
                                setShowLanguageAlert(false)
                            }}
                            style={styles.mainButton}
                        >
                            <Text style={styles.mainButtonText}>{languageFile.accept}</Text>
                        </TouchableOpacity>
                    </View>

                    <View style={styles.buttonContainer}>
                        <TouchableOpacity
                            onPress={() => {
                                setNewLanguage(defaultLanguage)
                                setShowLanguageAlert(false)
                            }}
                            style={styles.borderButton}
                        >
                            <Text style={styles.borderButtonText}>{languageFile.cancel}</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            )}
            {updating && (
                <View
                    style={[
                        StyleSheet.absoluteFill,
                        {
                            backgroundColor: 'rgba(0, 0, 0, 0.5)', // Fondo semi-transparente
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 9999,
                        },
                    ]}
                >
                    <ActivityIndicator color={'white'} size={50} />
                </View>
            )}
        </View>
    )
}

const EditProfileField = ({
    formData,
    item,
    handleVerificationClick,
    openModalEditValue,
    isButtonDisabledEmail,
    isButtonDisabledPhone,
    timerEmail,
    timerPhone,
    verifiedEmail,
    verifiedPhone,
    updateFormData,
    dataUpdated,
    cognitoHasPhone,
    cognitoHasEmail,
}) => {
    const isMobile = useIsMobile()
    const { languageFile } = getLanguage()
    const [tempValue, setTempValue] = useState(formData[item] ?? '')
    const isFieldEditable = isEnabledEditParams() && (item === 'Email' || item === 'Teléfono' || item === 'Apellido' || item === 'Nombre')
    const disableButtonPhone = isButtonDisabledPhone || dataUpdated
    const disableButtonEmail = isButtonDisabledEmail || dataUpdated

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60)
        const remainingSeconds = seconds % 60
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
    }
    const placeHolder = item === 'Teléfono' ? '123456777' : item.charAt(0).toUpperCase() + item.slice(1) ?? ''
    return (
        <View
            key={item}
            style={{
                flex: 1,
                paddingVertical: 16,
                marginHorizontal: 6,
                borderBottomWidth: 0.25,
                borderBottomColor: theme.colors.colorPrimary + '33',
                width: '100%',
            }}
        >
            <Text style={styles.tagInput}>{item.charAt(0).toUpperCase() + item.slice(1)}</Text>
            <View style={{ flex: 1, flexDirection: 'row', width: '100%' }}>
                {!isFieldEditable ? (
                    <Text style={[styles.data, !isMobile && { fontSize: 16 }, { marginVertical: 3 }]}>
                        {formData[item] ? formData[item] : item.charAt(0).toUpperCase() + item.slice(1)}
                    </Text>
                ) : (
                    <TextInput
                        style={[
                            styles.input,
                            { marginTop: 10, marginBottom: 0, width: '100%', flex: 1 },
                            (item === 'Email' || item === 'Teléfono') && { marginBottom: 10 },
                        ]}
                        onChangeText={(value) => {
                            if (item === 'Teléfono') {
                                // Maneja solo los números sin el prefijo en el input
                                let rawValue = value.startsWith('+549') ? value.slice(4) : value
                                // Limita a 10 caracteres
                                if (rawValue.length <= 10) {
                                    setTempValue(rawValue)
                                    updateFormData(item, rawValue)
                                }
                            } else {
                                setTempValue(value)
                                updateFormData(item, value)
                            }
                        }}
                        value={tempValue && tempValue.startsWith && tempValue.startsWith('+549') ? tempValue.slice(4) : tempValue}
                        placeholder={placeHolder}
                        placeholderTextColor={theme.colors.textSecondary}
                        keyboardType={item === 'Email' ? 'email-address' : 'default'}
                        autoCapitalize={item === 'Email' ? 'none' : 'words'}
                        editable={true}
                    />
                )}
                {item === 'Email' &&
                    isEnabledEditParams() &&
                    cognitoHasEmail &&
                    (verifiedEmail ? (
                        <View style={[styles.containerRow, { flex: 0 }]}>
                            <Text style={styles.textVerified}>{languageFile.verified}</Text>
                            <Feather name='check' size={iconSize} color={theme.colors.colorApproved} style={styles.marginLeft} />
                        </View>
                    ) : (
                        <TouchableOpacity
                            onPress={() => handleVerificationClick('email')}
                            disabled={disableButtonEmail}
                            style={[styles.containerRow, disableButtonEmail && { opacity: 0.5 }, { flex: 0 }]}
                        >
                            <Text style={styles.textToVerify}>
                                {isButtonDisabledEmail ? `Reintentar en ${formatTime(timerEmail)}s` : languageFile.verify}
                            </Text>
                            <Feather name='clock' size={iconSize} color={theme.colors.colorPrimary} style={styles.marginLeft} />
                        </TouchableOpacity>
                    ))}
                {item === 'Teléfono' &&
                    isEnabledEditParams() &&
                    cognitoHasPhone &&
                    (verifiedPhone ? (
                        <View style={[styles.containerRow, { flex: 0 }]}>
                            <Text style={styles.textVerified}>Verificado</Text>
                            <Feather name='check' size={iconSize} color={theme.colors.colorApproved} style={styles.marginLeft} />
                        </View>
                    ) : (
                        <TouchableOpacity
                            onPress={() => handleVerificationClick('phone')}
                            disabled={disableButtonPhone}
                            style={[styles.containerRow, disableButtonPhone && { opacity: 0.5 }, { flex: 0 }]}
                        >
                            <Text style={styles.textToVerify}>
                                {isButtonDisabledPhone ? `Reintentar en ${formatTime(timerPhone)}s ` : languageFile.verify}
                            </Text>
                            <Feather name='clock' size={iconSize} color={theme.colors.colorPrimary} style={styles.marginLeft} />
                        </TouchableOpacity>
                    ))}
            </View>
            {/* <View style={styles.inputRow}>
                {isEnabledEditParams() && (item === 'Email' || item === 'Teléfono' || item === 'Apellido' || item === 'Nombre') && (
                    <TouchableOpacity onPress={() => openModalEditValue(item)} style={[styles.editIcon, { flexDirection: 'row' }]}>
                        {!isMobile && (
                            <Text
                                style={{
                                    color: theme.colors.colorPrimary,
                                    marginEnd: 0,
                                    fontWeight: '700',
                                    fontSize: 15,
                                    height: 18,
                                    textAlignVertical: 'center',
                                    alignItems: 'center',
                                    alignContent: 'center',
                                }}
                            >
                                Editar
                            </Text>
                        )}
                        <Feather name='edit-2' size={iconSize} color={theme.colors.colorPrimary} style={[styles.marginLeft]} />
                    </TouchableOpacity>
                )}
            </View> */}
        </View>
    )
}
